const NavbarRoutes = [
  {
    navbarTitle: "Admin Dashboard",
    route: "/home",
    backIcon: false,
  },
  {
    navbarTitle: "Universities",
    route: "/universities/grid",
    backIcon: false,
  },
  {
    navbarTitle: "Universities",
    route: "/universities/",
    backIcon: true,
  },
  {
    navbarTitle: "Applications",
    route: "/applications",
    backIcon: false,
  },
  {
    navbarTitle: "Applications",
    route: "/applications/",
    backIcon: true,
  },
  {
    navbarTitle: "Meetings",
    route: "/meetings/upcoming",
    backIcon: false,
  },
  {
    navbarTitle: "Meetings",
    route: "/meetings/sent",
    backIcon: false,
  },
  {
    navbarTitle: "Meetings",
    route: "/meetings/received",
    backIcon: false,
  },
  {
    navbarTitle: "Add Meeting",
    route: "/meetings/add-meeting",
    backIcon: true,
  },
  {
    navbarTitle: "Reschedule Meeting",
    route: "/meetings/reschedule-meeting",
    backIcon: true,
  },
  {
    navbarTitle: "Chatbot",
    route: "/chatbot",
    backIcon: false,
  },
  {
    navbarTitle: "Notifications",
    route: "/notifications",
    backIcon: true,
  },
  {
    navbarTitle: "User Profile",
    route: "/profile",
    backIcon: true,
  },
  {
    navbarTitle: "Settings",
    route: "/settings",
    backIcon: false,
  },
  {
    navbarTitle: "Account Settings",
    route: "/account-settings",
    backIcon: true,
  },
  {
    navbarTitle: "Security Settings",
    route: "/security-settings",
    backIcon: true,
  },
  {
    navbarTitle: "Account Preferences",
    route: "/account-preference",
    backIcon: true,
  },
  {
    navbarTitle: "Visa Information",
    route: "/visa-information",
    backIcon: false,
  },
  {
    navbarTitle: "Visa Information",
    route: "/visa-information/",
    backIcon: true,
  },
  {
    navbarTitle: "Add Visa Information",
    route: "/visa-information/add",
    backIcon: true,
  },
  {
    navbarTitle: "Edit Visa Information",
    route: "/visa-information/edit-visa-info",
    backIcon: true,
  },
  {
    navbarTitle: "Countries",
    route: "/country",
    backIcon: false,
  },
  {
    navbarTitle: "Add Country",
    route: "/country/add",
    backIcon: true,
  },
  {
    navbarTitle: "Edit Country",
    route: "/country/edit-country/",
    backIcon: true,
  },
  {
    navbarTitle: "Students",
    route: "/students",
    backIcon: false,
  },
  {
    navbarTitle: "Students",
    route: "/students/",
    backIcon: true,
  },
  {
    navbarTitle: "Schools",
    route: "/schools/",
    backIcon: false,
  },
  {
    navbarTitle: "Internships",
    route: "/internships",
    backIcon: true,
  },
  {
    navbarTitle: "Schools",
    route: "/schools",
    backIcon: true,
  },
];
export default NavbarRoutes;
